import React, { useState, useEffect } from "react";
// import aboutUs from "../../PicesForPages/clientReviewjpg.jpg";

const reviews = [
  {
    content:
      "Kishore is an excellent and knowledgeable loan officer. I explored options with multiple banks, but he stood out by clearly explaining the process and guiding me every step of the way. He invested a lot of time in follow-ups and ensured everything stayed on track until closing. His patience, dedication, and transparency made the entire experience smooth. Highly recommended.",
    name: "- Haresh Pakki",
    location: "Mason , Ohio",
  },
  {
    content:
      "I had an incredible experience working with Kishore. From the very first meeting, he made the entire loan process seamless and stress-free. He is extremely knowledgeable, patient, and always took the time to explain every detail clearly. Kishore went above and beyond to ensure I got the best rates possible. I highly recommend him to anyone looking for a dedicated and professional loan officer.",
    name: "- Nagireddy Papana",
    location: "Plain City, Ohio",
  },
  {
    content:
      "Kishore is my go to person for all refinancing needs. He is highly knowledgeable, always accessible, and takes the time to patiently answer all of my questions. Thanks to his expertise, I was able to secure the best rate possible. I truly recommend him to anyone considering refinancing. I am  confident you will receive exceptional support and results. I also look forward to working with him on my upcoming home closing, knowing I will be in good hands and that the process will move smoothly and efficiently.",
    name: "- Viswanadha Raju Pericherla",
    location: "Powell, Ohio",
  },
  {
    content:
      "I had an excellent experience working with Kishore. He is very professional, knowledgeable, and very responsive throughout the entire process. Every step was explained clearly, and he made the loan process smooth and stress-free. His dedication and support helped us close on time with confidence. I truly appreciate his  outstanding service and highly recommend him to anyone looking for a reliable mortgage professional.",
    name: "- Mahendra Vakati ",
    location: "Delaware, Ohio",
  },
  {
    content:
      "I had been planning to refinance my home for some time, and I am so glad I reached out to Kishore for this work. The way he managed the entire documentation and process was truly top-class and saved me from a lot of headache. Kishore is a very sincere professional who puts in great effort to find a beneficial deal while explaining all the terms very simply. If you are looking for a reliable person for your mortgage needs, you can surely trust Kishore for excellent results.",
    name: "- RamamahendraReddy Guda",
    location: "Delaware, Ohio",
  },
  {
    content:
      "Highly recommend Kishore for your mortgage needs!\nI recently worked with Kishore for my home refinance, and the experience was outstanding from start to finish. What truly set him apart was how he took the time to educate me on every step of the loan process before we even began. I never felt lost or overwhelmed — he made sure I understood exactly what was happening and why.\nWhenever I had doubts or concerns, Kishore was always available for a meeting. His patience, transparency, and dedication made the entire process incredibly smooth.",
    name: "- Rajesh Reddy Narra",
    location: "Delaware, Ohio",
  },
  {
    content:
      "I had a wonderful experience working with Kishore throughout my loan journey. From start to finish, he made the entire process smooth, transparent, and worry-free. His expertise, patience, and clear communication gave me complete confidence every step of the way. Kishore worked tirelessly to secure the best possible rate for me and was always available to answer my questions. I truly appreciate his dedication and highly recommend him to anyone seeking a trustworthy and professional loan officer.",
    name: "- Ebenezer Alfred George",
    location: "Delaware, Ohio",
  },
  {
    content:
      "Kishore went above and beyond during my mortgage process. His deep knowledge and willingness to explain every detail made a huge difference. He is patient, responsive, and genuinely cares about helping you get the best outcome. Thanks to him, the entire experience was smooth and stress-free. I would confidently recommend him to anyone looking for mortgage assistance.",
    name: "- Ravikumar Sure Venkata",
    location: "Delaware, Ohio",
  },
  {
    content:
      "Working with Kishore has been an excellent experience. He is extremely knowledgeable and always willing to answer questions with patience and clarity. I appreciated how he took the time to understand my needs and guided me toward the best available options at every step. His professionalism, responsiveness, and genuine desire to help make him stand out. I would confidently recommend Kishore to anyone looking for a reliable and supportive Loan Officer.",
    name: "- Naga Phanindra Pulipati",
    location: "Delaware, Ohio",
  },
  {
    content:
      "I worked with Kishore who made my home refinancing process incredibly smooth. He was instrumental in navigating the complexities of a Solar UCC termination, handling the coordination with the solar company and title with ease. His expertise saved me a significant amount of time and was able to close on time. I highly recommend their services for anyone needing a proactive and knowledgeable mortgage professional!",
    name: "- Ashwin Bhogle",
    location: "Mundelein, Illinois",
  },
  {
    content:
      "Working with Kishore was a great experience. As a loan provider, he brings clarity, patience, and strong follow-through to the entire process. He keeps everything on track and makes sure there are no surprises along the way. I highly recommend him for anyone seeking a smooth and hassle-free loan process.",
    name: "- Suresh Bhandari",
    location: "Canton, Georgia",
  },
];

function ClientReview() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 5000); // Change every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const currentReview = reviews[currentIndex];
  return (
    <div className="OurSatisfiedBoxParent">
      <div className="OurSatisfiedBox fade-in">
        <span className="OurSatisfiedHeading">Our Satisfied Clients</span>
        <span className="OurSatisfiedContentBoxParent">
          <span className="OurSatisfiedContentBox" key={currentIndex}>
            <span className="OurSatisfiedStars">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </span>
            <span className="OurSatisfiedContent">
              {currentReview.content
                .split("VIDHI MORTGAGE LLC")
                .map((part, i, arr) =>
                  i < arr.length - 1 ? (
                    <React.Fragment key={i}>
                      {part}
                      <span className="brand_text">VIDHI MORTGAGE LLC</span>
                    </React.Fragment>
                  ) : (
                    part
                  ),
                )}
            </span>
            <span className="OurSatisfiedNameLocation">
              <span className="OurSatisfiedName">{currentReview.name}</span>
              <span className="OurSatisfiedLocation">
                {currentReview.location}
              </span>{" "}
            </span>
          </span>
          {/* <span>dot</span> */}
        </span>
      </div>

      <span className="OurSatisfiedArrows">
        <i
          className="ri-arrow-left-wide-fill OurSatisfiedLeftArrow"
          onClick={() =>
            setCurrentIndex((prev) =>
              prev === 0 ? reviews.length - 1 : prev - 1,
            )
          }
        ></i>
        <i
          className="ri-arrow-right-wide-fill OurSatisfiedRightArrow"
          onClick={() => setCurrentIndex((prev) => (prev + 1) % reviews.length)}
        ></i>
      </span>
    </div>
  );
}

export default ClientReview;
